import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23 3H1v18h22V3zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z"
}), 'PhotoSizeSelectActualSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PhotoSizeSelectActualSharp.js
// module id = 5453
// module chunks = 2